import { render, staticRenderFns } from "./ApprovedApplications.vue?vue&type=template&id=64202859"
import script from "./ApprovedApplications.vue?vue&type=script&lang=js"
export * from "./ApprovedApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports